(() => {
	angular.module('main').component('userHome', userHome());

	userHome.$inject = [];

	function userHome() {
		return {
			template: require('./userHome.component.html'),
			controller: 'HomeController'
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/home/userHome.component.js